import EventBusConfig from '../config/eventBusConfig';
import { EventBus } from '../vue';

export default {
  data() {
    return {
      pageTitle: null,
      pageType: null,
    };
  },

  watch: {
    pageTitle() {
      EventBus.$emit(EventBusConfig.events.pageTitleLoaded, {
        pageTitle: this.pageTitle,
        pageType: this.pageType,
      });
    },
  },
};
